<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF ALLIED HEALTH SCIENCES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Anesthesia</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Science in Anesthesia</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Science in Anesthesia </b>
                    – The Bachelor of Science in Anesthesia (B.Sc. Anesthesia) offered by ARNI School of Allied Health
                    Sciences is a three-year undergraduate program designed to equip students with the knowledge and
                    skills
                    required to assist anesthesiologists in surgical procedures. This course focuses on anesthesia
                    techniques, pre-operative and post-operative care, pain management, and critical care procedures.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b></p>
                <ul>
                    <li> Biochemistry</li>
                    <li> Physiology</li>
                    <li> Human Anatomy</li>
                    <li> General Psychology</li>
                    <li> Introduction to Anesthesia Technology</li>
                    <li> Elective – I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b></p>
                <ul>
                    <li> Pharmacology</li>
                    <li> Microbiology</li>
                    <li> Applied Pathology</li>
                    <li> Basic Food & Nutrition</li>
                    <li> Anesthesia Technology – Applied</li>
                    <li> Elective – II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b></p>
                <ul>
                    <li> Environmental Science</li>
                    <li> Medicine Relevant to Anesthesia Technology</li>
                    <li> Hematology & Blood –Banking</li>
                    <li> Sociology</li>
                    <li> Elective -III</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b></p>
                <ul>
                    <li> CSSD Procedures</li>
                    <li> Anesthesia Technology- Clinical</li>
                    <li> Clinical Training</li>
                    <li> Elective -IV</li>
                    <li> Elective – V</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b></p>
                <ul>
                    <li> Post-Anesthesia Care Unit</li>
                    <li> Anesthesia Technology- Clinical II</li>
                    <li> Anesthesia Technology-Applied II</li>
                    <li> Clinical Training</li>
                    <li> Elective – VI</li>
                    <li> Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b></p>
                <ul>
                    <li> Regional Anesthetic Techniques</li>
                    <li> Anesthesia for Specialty Surgeries</li>
                    <li> Anesthesia Technology- Advanced</li>
                    <li> Clinical Training</li>
                    <li> Assignment/ Practical</li>
                </ul>
            </div>

        </div>

    </div>
</section>
